import HomeOne from "./HomeOne";
import Contact from "./Contact";
import Faq from "./Faq";
import Event from "./Event";
import FeaturesPage from "./FeaturesPage";
import AcademyPage from "./AcademyPage";
import AcademyDetail from "./AcademyDetail";
import PricingPage from "./PricingPage";
import PrivacyPolicy from "./PrivacyPolicy";
import SyaratKetentuanMentor from "./SyaratKetentuanMentor";
import MentorPage from "./MentorPage";

const routes = [
  { path: '/', component: <HomeOne />},
  { path: '/contact', component: <Contact />},
  { path: '/faq', component: <Faq />},
  { path: '/event', component: <Event />},
  { path: '/features', component: <FeaturesPage />},
  { path: '/academy', component: <AcademyPage />},
  { path: '/academy/:id', component: <AcademyDetail />},
  { path: '/pricing', component: <PricingPage />},
  { path: '/kebijakan-privasi', component: <PrivacyPolicy />},
  { path: '/mentor', component: <MentorPage />},
  { path: '/syarat-ketentuan-mentor', component: <SyaratKetentuanMentor />},
]

export default routes;
